<template>
    <q-page class="q-pa-md">
        Not Found
    </q-page>
</template>

<script>
    export default {
        data() {
            return {
            }
        }
    }
</script>
